export default {
  update (state, data) {
    state.diaryList = data
  }
}
